import "./Header.scss";
import Button from "./Button";
import Logo from "../../assets/images/logo.png";
import { useState } from "react";
import { ReactComponent as Menu } from "../../assets/icons/menu.svg";
import { Add } from "iconsax-react";
import { NavLink } from "react-router-dom";

// sidebar icons
import { ReactComponent as AboutUs } from "../../assets/icons/about-us.svg";
import { ReactComponent as OurProducts } from "../../assets/icons/our-products.svg";
import { ReactComponent as Roadmap } from "../../assets/icons/roadmap.svg";
import { ReactComponent as AurToken } from "../../assets/icons/aur-token.svg";
import { ReactComponent as GetInTouch } from "../../assets/icons/get-in-touch.svg";

// sidebar socials
import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";
import { ReactComponent as GitbookIcon } from "../../assets/icons/Gitbook.svg";
import { ReactComponent as GithubIcon } from "../../assets/icons/Github.svg";
import { ReactComponent as DexToolsIcon } from "../../assets/icons/DexTools.svg";
import { ReactComponent as DexscreenerIcon } from "../../assets/icons/Dexscreener.svg";

export default function Header() {
	const [isHovered, setIsHovered] = useState(false);

	/* sidebar active */
	const [sidebarActive, setSidebarActive] = useState(false);

	const toggleSidebar = () => {
		setSidebarActive(!sidebarActive);
	};

	const closeSidebar = () => {
		setSidebarActive(false);
	};

	const handleScroll = (e) => {
		e.preventDefault(); // Prevent default anchor behavior
		closeSidebar();
		const target = e.target.getAttribute("href").substring(1);
		const targetElement = document.querySelector(target);
		const headerHeight = document.querySelector(".header").offsetHeight;

		const yOffset = -headerHeight; // Negative offset to account for the header
		const yPosition =
			targetElement.getBoundingClientRect().top +
			window.pageYOffset +
			yOffset;

		window.scrollTo({ top: yPosition, behavior: "smooth" });
	};

	return (
		<div className="header">
			<div className="decoration header-light-1"></div>

			<div className="header-content content-wrapper-lg">
				<div className="header-left">
					{!sidebarActive && (
						<button
							className="sidebar-toggle"
							onClick={toggleSidebar}
						>
							<Menu />
						</button>
					)}
				</div>

				<div className="header-center">
					<img className="header-logo" src={Logo} alt="logo" />
				</div>

				<div className="header-right">
					<Button
						className="launch-dapp-btn"
						onMouseEnter={() => setIsHovered(true)}
						onMouseLeave={() => setIsHovered(false)}
					>
						{isHovered ? "COMING SOON" : "DApp"}
					</Button>
				</div>
			</div>

			<div
				className={`sidebar-backdrop ${sidebarActive ? "active" : ""}`}
				onClick={closeSidebar}
			></div>
			<div className={`sidebar ${sidebarActive ? "active" : ""}`}>
				<div className="sidebar-content-wrapper content-wrapper-lg">
					<div className="sidebar-content">
						<div className="sidebar-header">
							<button
								className="sidebar-close"
								onClick={closeSidebar}
							>
								<Add
									size="40"
									color="#808080"
									className="add-icon"
								/>
							</button>
						</div>

						<div className="sidebar-body">
							<ul className="sidebar-nav">
								<li>
									<a href="/#about-us" onClick={handleScroll}>
										<AboutUs className="sidebar-nav-icon" />
										About Us
									</a>
								</li>
								<li>
									<a
										href="/#our-products"
										onClick={handleScroll}
									>
										<OurProducts className="sidebar-nav-icon" />
										Our Products
									</a>
								</li>
								<li>
									<a href="/#roadmap" onClick={handleScroll}>
										<Roadmap className="sidebar-nav-icon" />
										Roadmap
									</a>
								</li>
								<li>
									<a
										href="/#tokenomics"
										onClick={handleScroll}
									>
										<AurToken className="sidebar-nav-icon" />
										AUR Token
									</a>
								</li>
								<li>
									<a
										href="/#contact-us"
										onClick={handleScroll}
									>
										<GetInTouch className="sidebar-nav-icon" />
										Get In Touch
									</a>
								</li>
							</ul>

							<div className="sidebar-socials">
								<ul>
									<li>
										<a href="https://t.me/UseAurAI">
											<TelegramIcon className="social-btn-icon" />
										</a>
									</li>
									<li>
										<a href="https://x.com/meetaurai">
											<XLogo className="social-btn-icon" />
										</a>
									</li>
									<li>
										<a href="#-">
											<GithubIcon className="social-btn-icon" />
										</a>
									</li>
									<li>
										<a href="#-">
											<DexscreenerIcon className="social-btn-icon" />
										</a>
									</li>
									<li>
										<a href="https://aur-ai.gitbook.io/aurai">
											<GitbookIcon className="social-btn-icon" />
										</a>
									</li>
									<li>
										<a href="#-">
											<DexToolsIcon className="social-btn-icon" />
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
